import { Point, RopeElement, RopeEnd, SnapCandidate } from './types'
import { snapCandidateToContact, snapCandidateToRopeEnd } from './rope-geometry'

export function setRopeEndpoint(
  rope: RopeElement,
  end: 'start' | 'end',
  candidate: SnapCandidate | null,
  point: Point,
): RopeElement {
  let next: RopeEnd = snapCandidateToRopeEnd(candidate, point)
  if (end === 'start' && next.mode === 'free') {
    next = { ...next, fallsToGround: true }
  }
  if (end === 'start') return { ...rope, start: next }
  return { ...rope, end: next }
}

export function setRopeContact(rope: RopeElement, index: number, candidate: SnapCandidate): RopeElement {
  if (index < 0 || index >= rope.contacts.length) return rope
  const contact = snapCandidateToContact(candidate)
  const contacts = rope.contacts.slice()
  contacts[index] = contact
  return { ...rope, contacts }
}

export function removeRopeContact(rope: RopeElement, index: number): RopeElement {
  if (index < 0 || index >= rope.contacts.length) return rope
  return { ...rope, contacts: rope.contacts.filter((_, i) => i !== index) }
}

export function insertRopeContactAt(
  rope: RopeElement,
  insertIndex: number,
  candidate: SnapCandidate,
): RopeElement {
  const contact = snapCandidateToContact(candidate)
  const idx = Math.max(0, Math.min(insertIndex, rope.contacts.length))
  const contacts = [...rope.contacts.slice(0, idx), contact, ...rope.contacts.slice(idx)]
  return { ...rope, contacts }
}
